import { render, staticRenderFns } from "./modifycheckContent.vue?vue&type=template&id=3a5f1433&"
import script from "./modifycheckContent.vue?vue&type=script&lang=js&"
export * from "./modifycheckContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5f1433')) {
      api.createRecord('3a5f1433', component.options)
    } else {
      api.reload('3a5f1433', component.options)
    }
    module.hot.accept("./modifycheckContent.vue?vue&type=template&id=3a5f1433&", function () {
      api.rerender('3a5f1433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/modifycheckContent.vue"
export default component.exports